import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ServiceHttpBase } from './service-http-base.service';
import { DropDownModel } from '../models/dropdown.model';
import { DistrictModel } from '../models/district.model';

@Injectable({
  providedIn: 'root',
})
export class DropDownService extends ServiceHttpBase {

  actFreqURL = this.baseURL + '/DropDownSelector/GetActFreqSelector';
  agencyURL = this.baseURL + '/DropDownSelector/GetAgencySelector';
  bankURL = this.baseURL + '/DropDownSelector/GetBankSelector';
  cloneTypeURL = this.baseURL + '/DropDownSelector/GetCloneTypeSelector';
  districtURL = this.baseURL + '/DropDownSelector/GetDistrictSelector';
  dunURL = this.baseURL + '/DropDownSelector/GetDunSelector';
  educationLevelURL = this.baseURL + '/DropDownSelector/GetEducationLevelSelector';
  lotCategoryURL = this.baseURL + '/DropDownSelector/GetLotCategoriesSelector';

  lotRuleURL = this.baseURL + '/DropDownSelector/GetLotRulesSelector';
  officeURL = this.baseURL + '/DropDownSelector/GetOfficeSelector';
  raceURL = this.baseURL + '/DropDownSelector/GetRacesSelector';
  stateURL = this.baseURL + '/DropDownSelector/GetStateSelector';
  stateBySubDivisionIdURL = this.baseURL + '/DropDownSelector/GetStateSelectorBySubDivisionId';
  subdivisionURL = this.baseURL + '/DropDownSelector/GetSubDivisionSelector';
  parliamentURL = this.baseURL + '/DropDownSelector/GetParliamentSelector';
  categoryURL = this.baseURL + '/DropDownSelector/GetCategorySelector';
  maritalstatusURL = this.baseURL + '/DropDownSelector/GetMaritalStatusSelector';
  incomeLevelURL = this.baseURL + '/DropDownSelector/GetIncomeLevelSelector';
  rubberTypeURL = this.baseURL + '/DropDownSelector/GetRubberTypeSelector';
  rubberOutputURL = this.baseURL + '/DropDownSelector/GetRubberOutputSelector';
  subDivisionByDistrictIdURL = this.baseURL + '/SubDivision/GetByDistrictId/?districtId=';
  districtBySubDivIdURL = this.baseURL + '/DropDownSelector/GetDistrictBySubDivisionId/?subDivisionId=';
  subCategoryURL = this.baseURL + '/DropDownSelector/GetSubCategorySelector';
  fractionURL = this.baseURL + '/DropDownSelector/GetFractionSelector';
  otherMemberIncomeTypeURL = this.baseURL + '/DropDownSelector/GetOtherIncomeLevelSelector';
  constructor(private http: HttpClient) {
    super();
  }

  getActFreqs() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.actFreqURL);
    return list;
  }


  getAgencies() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.agencyURL);
    return list;
  }

  getBanks() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.bankURL);
    return list;
  }

  getCloneTypes() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.cloneTypeURL);
    return list;
  }

  getOtherMemberIncomeTypes() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.otherMemberIncomeTypeURL);
    return list;
  }

  getDistricts() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.districtURL);
    return list;
  }

  geteducationLevels() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.educationLevelURL);
    return list;
  }

  getLotCategories() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.lotCategoryURL);
    return list;
  }

  getDuns() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.dunURL);
    return list;
  }

  getLotRule() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.lotRuleURL);
    return list;
  }

  getOffice() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.officeURL);
    return list;
  }

  getRaces() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.raceURL);
    return list;
  }


  getStates() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.stateURL);
    return list;
  }

  getStateBySubDivisionId(subDivId: number) : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.stateBySubDivisionIdURL + "/?subDivisionId=" + subDivId);
    return list;
  }


  getSubdivisions() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.subdivisionURL);
    return list;
  }

  getParliaments() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.parliamentURL);
    return list;
  }

  getCategories() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.categoryURL);
    return list;
  }

  getMaritalStatus(): Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list = this.http.get<DropDownModel>(this.maritalstatusURL);
    return list;
  }

  getIncomeLevel(): Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list = this.http.get<DropDownModel>(this.incomeLevelURL);
    return list;
  }

  getRubberType(): Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list = this.http.get<DropDownModel>(this.rubberTypeURL);
    return list;
  }

  getRubberOutput(): Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list = this.http.get<DropDownModel>(this.rubberOutputURL);
    return list;
  }

  getSubDivisionByDistrictId(districtId: number): Observable<DropDownModel> {
    var list = this.http.get<DropDownModel>(this.subDivisionByDistrictIdURL + districtId);
    return list;
  }

  getDistrictBySubDivId(subDivId: number): Observable<DistrictModel> {
    var list = this.http.get<DistrictModel>(this.districtBySubDivIdURL + subDivId);
    return list;
  }

  getSubCategories() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.subCategoryURL);
    return list;
  }

  getFractions() : Observable<DropDownModel> {
    //console.log(this.actFreqURL);
    var list=this.http.get<DropDownModel>(this.fractionURL);
    return list;
  }
}
